import { Box, Button, Divider, Modal, Stack, Typography } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { CloseIcon } from "@/assets";

const styles = {
  modalRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    width: "600px",
    bgcolor: "background.paper",
    borderRadius: 2,
    outline: "none",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "30px",
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  headerIcon: {
    color: "primary.main",
    fontSize: "24px",
  },
  headerText: {
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "30px",
    color: "#333333",
  },
  closeIcon: {
    cursor: "pointer",
    fontSize: "18px",
  },
  content: {
    padding: "30px",
  },
  contentText: {
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "28px",
    color: "#333333",
  },
  actions: {
    padding: "0 30px 30px",
  },
};

interface MissingReportConfigurationModalProps {
  open: boolean;
  onClose: () => void;
  onGenerateAnyway: () => void;
  onGoToConfiguration: () => void;
}

export const MissingReportConfigurationModal = ({
  open,
  onClose,
  onGenerateAnyway,
  onGoToConfiguration,
}: MissingReportConfigurationModalProps): JSX.Element => {
  const { t } = useTranslation("ValuationAnalysisPage");

  return (
    <Modal open={open} sx={styles.modalRoot}>
      <Box sx={styles.modalContainer} data-cy="missing-report-configuration-modal">
        <Box sx={styles.header}>
          <Box sx={styles.headerContent}>
            <Typography sx={styles.headerText}>{t("missingReportConfigurationDialog.title")}</Typography>
          </Box>
          <CloseIcon sx={styles.closeIcon} onClick={onClose} color="primary" />
        </Box>
        <Divider />
        <Box sx={styles.content}>
          <Typography sx={styles.contentText}>{t("missingReportConfigurationDialog.message")}</Typography>
        </Box>
        <Box sx={styles.actions}>
          <Stack spacing={"30px"} direction="row" justifyContent="flex-end" sx={{ height: "45px" }}>
            <Button onClick={onGoToConfiguration} color="secondary" variant="contained">
              {t("missingReportConfigurationDialog.goToConfiguration")}
            </Button>
            <Button autoFocus onClick={onGenerateAnyway} variant="contained" color="primary">
              {t("missingReportConfigurationDialog.downloadAnyway")}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
